import { Injectable } from '@angular/core';
import { SocketService } from '@frontend/common/util';
import { createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import {
  GlobalCreateSiteSuccessWs,
  GlobalRemoveSiteSuccessWs,
  GlobalUpdateSiteSuccessWs,
  LocalCreateSiteFailureWs,
  LocalCreateSiteSuccessWs,
  LocalRemoveSiteFailureWs,
  LocalRemoveSiteSuccessWs,
  LocalUpdateSiteFailureWs,
  LocalUpdateSiteSuccessWs,
} from './site-ws.actions';

@Injectable()
export class SiteWsEffects {
  LocalCreateSiteSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('sites.create')
      .pipe(
        map(
          ({ id, correlation_id }) => new LocalCreateSiteSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalCreateSiteFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('sites.create')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalCreateSiteFailureWs({ correlation_id, message })
        )
      )
  );

  LocalUpdateSiteSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('sites.update')
      .pipe(
        map(
          ({ id, correlation_id }) => new LocalUpdateSiteSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalUpdateSiteFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('sites.update')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalUpdateSiteFailureWs({ correlation_id, message })
        )
      )
  );

  LocalRemoveSiteSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('sites.remove')
      .pipe(map(({ correlation_id }) => new LocalRemoveSiteSuccessWs({ correlation_id })))
  );

  LocalRemoveSiteFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('sites.remove')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalRemoveSiteFailureWs({ correlation_id, message })
        )
      )
  );

  GlobalCreateSiteSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('sites.create')
      .pipe(map(() => new GlobalCreateSiteSuccessWs()))
  );

  GlobalUpdateSiteSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('sites.update')
      .pipe(map((site: any) => new GlobalUpdateSiteSuccessWs({ site })))
  );

  GlobalRemoveSiteSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('sites.remove')
      .pipe(map(({ id }: any) => new GlobalRemoveSiteSuccessWs({ id })))
  );

  constructor(private socketSrv: SocketService) {}
}
